import script from "./DetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailList.vue?vue&type=script&setup=true&lang=js"

import "./DetailList.vue?vue&type=style&index=0&id=51eb23cb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51eb23cb"]])

export default __exports__